//
import React from "react"

//
import Layout from '../layout/index';
import QRCodeMenu from 'routes/qr-code-menu/index.js';

/*
 *
 */
export default (props) => (
	<Layout {...props}>
		<QRCodeMenu />
	</Layout>
);